import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [status, setStatus] = useState({ payment_status: "pending", amount: 0, type: "" });
  const [checks, setChecks] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sid = params.get("session_id");
    if (!sid) return;
    let cancelled = false;

    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        setStatus(data);
        if (data.payment_status !== "paid" && checks < 15) {
          setTimeout(poll, 2000);
          setChecks((c) => c + 1);
        }
      } catch (_) {}
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, []);

  const paid = status.payment_status === "paid";

  return (
    <div data-testid="payment-success-page" className="min-h-[60vh] grid place-items-center px-4 py-14">
      <div className="w-full max-w-lg bg-[#FFFDF9] sacred-border rounded-3xl p-10 text-center relative om-watermark">
        {paid ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-[#2F7D32] mx-auto" />
            <div className="overline mt-5">Offering received</div>
            <h1 className="font-serif text-4xl text-[#4A0E17] mt-2">॥ धन्यवाद ॥</h1>
            <p className="text-[#63534E] mt-4 leading-relaxed">
              Your {status.type === "booking" ? "booking" : "seva"} of <span className="font-mono text-[#E65100] font-semibold">${status.amount?.toFixed(2)}</span> has been received. A confirmation has been sent to your email.
            </p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-full border-4 border-[#D4AF37] border-t-transparent mx-auto animate-spin" />
            <h1 className="font-serif text-3xl text-[#4A0E17] mt-6">Confirming your offering…</h1>
            <p className="text-[#63534E] mt-3">This usually takes a moment. Please don't close this tab.</p>
          </>
        )}
        <Link to="/" data-testid="back-home" className="btn-primary mt-8">Return home</Link>
      </div>
    </div>
  );
}
